import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserMenu from './UserMenu.jsx';
import useDarkMode from '../hooks/useDarkMode';

function Topbar({ currentUser, logout }) {
  const [darkMode, setDarkMode] = useDarkMode();
  const [isIframe, setIsIframe] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Detect if we're in an iframe
    setIsIframe(window !== window.parent);
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  // If we're in an iframe, do not show
  if (isIframe)
    return null;

  // Normal render outside iframe
  return (
    <div className="shrink-0 border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
      <div className="flex h-12 w-full items-center justify-between px-4">
        <a
          href="/"
          className="cursor-pointer text-lg font-semibold text-gray-800 dark:text-white"
          onClick={(e) => {
            e.preventDefault();
            navigate('/');
          }}
        >
          Globe Data
        </a>

        {/* Right side: User menu */}
        <div className="flex items-center space-x-4">
          <UserMenu
            currentUser={currentUser}
            logout={logout}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
          />
        </div>
      </div>
    </div>
  );
}

export default Topbar;